import React from "react";
import "./PreferredEnergy.css";
import energyillustration from "../../assets/energy-illustration.svg";

const PreferredEnergy = () => {
  return (
    <section className="preferred-energy-section">
      <div className="preferred-energy-content">

        {/* Subtext */}
        <p className="preferred-energy-subheading">
          MAKING INDIA'S &nbsp; <span>POWER MOVE</span>
        </p>

        {/* Main Heading */}
        <h2 className="preferred-energy-title">
          India’s preferred renewable energy solutions provider
        </h2>

        {/* Image Section */}
        <div className="preferred-energy-illustration">
          <img
            src={energyillustration}
            alt="Renewable Energy Diagram"
            className="preferred-energy-image"
          />
        </div>
      </div>
    </section>
  );
};

export default PreferredEnergy;
